import { Card, FaIcon, FaIcons, Spinner } from '@innovationnorway/component-library';
import { useNavigate } from 'react-router-dom';
import { localizationNavMenu } from '../../../assets/localizations/localizationNavMenu';
import { useLocalizer } from '../../../hooks';
import { apiClient } from '../../../lib/query/apiClient';

export const ActionCards = () => {
  const { typeSafeL } = useLocalizer('NavMenu');

  const localization = typeSafeL<typeof localizationNavMenu>;

  const navigate = useNavigate();

  const { data: unreadCountData, isLoading } = apiClient.useQuery('get', '/api/v1/Documents/GetUnreadCount');

  const cards = [
    {
      id: 'documents',
      title: localization('documents'),
      onClick: () => navigate('/documents'),
      loading: isLoading,
      unreadCount: unreadCountData?.unreadCount,
    },
    {
      id: 'apply-for-change',
      title: localization('applyForChange'),
      onClick: () => navigate('/apply-for-change'),
    },
  ];

  return (
    <div className={'mb-4 grid grid-cols-1 gap-4 md:grid-cols-2'}>
      {cards.map((card) => (
        <Card key={card.id} onClick={card.onClick} className="group" backgroundColor={'blue-25'}>
          <div className="flex items-center">
            <div className="flex items-center flex-1">
              <h4 className="m-0 text-lg font-semibold group-hover:underline">{card.title}</h4>
              {card.loading ? (
                <Spinner className="flex items-center ml-4" />
              ) : (
                typeof card.unreadCount === 'number' &&
                card.unreadCount > 0 && <span className="flex items-center justify-center h-5 px-2 ml-4 text-sm font-bold text-black rounded-full bg-in-blue-100 min-w-5">{card.unreadCount}</span>
              )}
            </div>
            <FaIcon name={FaIcons.ArrowRight} />
          </div>
        </Card>
      ))}
    </div>
  );
};
